import {
  AddIcon,
  Box,
  Divider,
  HStack,
  Pressable,
  ScrollView,
  Text,
  VStack,
  CloseIcon,
  Button,
  Image,
  Input,
  IconButton,
} from "native-base";
import React, {
  FC,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import Tooltip from "@mui/material/Tooltip";
import AVCancel from "../../../components/common/AVCancel";
import AVEmoji from "../../../components/common/AVEmoji";
import { StyleSheet } from "react-native";
import * as AV from "../../../AVCore/AVCore";
import {
  VideoIcon,
  DropdownIcon,
  ExpandIcon,
  CollapseIcon,
  BrushIcon,
  ImportBGImage,
  CancelIcon,
  FormattingIcon,
  CircleSlashIcon,
} from "../../../assets/icons/icon-assets";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import { Loc } from "../../../App/Loc";
import { Media, Post, Person } from "../../../AVCore/AVCore";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setFeeds } from "../../../Redux/Actions/feedsAction";
import { v4 as uuidv4 } from "uuid";
import AVEmojiPicker from "../../../components/common/AVEmojiPicker";
import { setisActive } from "../../../Redux/Actions/userActions";
import AVInputtext from "../../../components/AVInputtext";
//import LinkPreview from "./preview/LinkPreview";
import CustomToast from "../../../Hooks/useCustomToast";
import useDrivePicker from "react-google-drive-picker";
import Webcam from "react-webcam";
import { FiCamera, FiVideo } from "react-icons/fi";
import axios from "axios";
import ExternalLink from "../../../components/common/ExternalLink";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import type SunEditorCore from "suneditor/src/lib/core";
import { SketchPicker } from "react-color";
import CreatePostGrid from "../../../Screens/Home/CreatePostGrid";

interface Props {
  editorRef: any;
  useRichText: boolean;
  setUseRichText: Dispatch<SetStateAction<boolean>>;
  rteValue: string;
  setRteValue: Dispatch<SetStateAction<string>>;
  toolbarOptions?: Record<string, any>;
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
  setPostPopupExpanded: Dispatch<SetStateAction<boolean>>;
  bgColor: string;
  setBgColor: Dispatch<SetStateAction<string>>;
  bgImage: string;
  setBgImage: Dispatch<SetStateAction<string>>;
  bgImgWidth: string;
  setBgImgWidth: Dispatch<SetStateAction<string>>;
  bgImgHeight: string;
  setBgImgHeight: Dispatch<SetStateAction<string>>;
  isOpenConvo: boolean;
  entityStatus?: string;
  toFK?: any;
  subject?: string;
  isConfirmDelete?: boolean;
  convo?: any;
  handleSendConvoMessage: (convo: any) => Promise<void>;
  Loading?: boolean;
  isLoading?: boolean;
  itemEdit?: any;
  setItemEdit: Dispatch<SetStateAction<any>>;
  handleUpdatePost: (itemEdit: any) => Promise<void>;

  // OneDrive / YouTube / Camera
  setIsOneDriveData?: Dispatch<SetStateAction<boolean>>;
  isYoutube?: boolean;
  setIsYouTube?: Dispatch<SetStateAction<boolean>>;
  isOpenCemera?: boolean;
  setIsOpenCemera?: Dispatch<SetStateAction<boolean>>;
  cameraMode?: "photo" | "video";
  setCameraMode?: Dispatch<SetStateAction<"photo" | "video">>;

  // External links
  externalLink?: string;
  setExternalLink?: Dispatch<SetStateAction<string>>;
  showExternalLinkInput?: boolean;
  setShowExternalLinkInput: Dispatch<SetStateAction<boolean>>;
  addLinkLoad?: boolean;

  // File handling
  handleOpenPicker?: () => void;
  HandleAddOneDrive?: () => void;
  HandleAddDropBoxLink?: () => void;
  handleExternalLink?: () => void;
  HandleAddExternalUrl: () => void;

  // Camera / recording
  webcamRef?: any;
  recording?: string;
  duration: string;
  formatDuration: (value: string) => void;
  toggleMode: () => void;
  isCancelledRef?: any;
  handleCameraPhotoCapture?: () => void;
  handleStartRecording: () => void;
  handleStopRecording: () => void;
  onClose: () => void;

  // Media handling
  RenderImages;
  handleImages: () => void;
  images?: any;
  setImages?: any;
  setIsdelete?: boolean;
  setDeletedImages?: Dispatch<SetStateAction<string[]>>;
  setUpdateConvoImage: Dispatch<SetStateAction<AV.IMedia[]>>;
  setUpdateConvoVideo: Dispatch<SetStateAction<AV.IMedia[]>>;
  media?: AV.IMedia[];
  setMedia: Dispatch<SetStateAction<AV.IMedia[]>>;
  isImageProcessing?: boolean;
  editingImage?: boolean;
  setEditingImage: Dispatch<SetStateAction<boolean>>;
  setShowConvoFilePicker: Dispatch<SetStateAction<boolean>>;
}

const FormattingPostPopup: FC<Props> = ({
  editorRef,
  useRichText,
  setUseRichText,
  rteValue,
  setRteValue,
  toolbarOptions,
  isExpanded,
  setIsExpanded,
  setPostPopupExpanded,
  bgColor,
  setBgColor,
  bgImage,
  setBgImage,
  bgImgWidth,
  setBgImgWidth,
  bgImgHeight,
  setBgImgHeight,
  isOpenConvo,
  entityStatus,
  toFK,
  subject,
  isConfirmDelete,
  convo,
  handleSendConvoMessage,
  isLoading,
  itemEdit,
  setItemEdit,
  handleUpdatePost,
  setIsOneDriveData,
  isYoutube,
  setIsYouTube,
  isOpenCemera,
  setIsOpenCemera,
  cameraMode,
  setCameraMode,
  externalLink,
  setExternalLink,
  showExternalLinkInput,
  setShowExternalLinkInput,
  addLinkLoad,
  handleOpenPicker,
  HandleAddOneDrive,
  HandleAddDropBoxLink,
  handleExternalLink,
  HandleAddExternalUrl,
  webcamRef,
  recording,
  duration,
  formatDuration,
  toggleMode,
  isCancelledRef,
  handleCameraPhotoCapture,
  handleStartRecording,
  handleStopRecording,
  onClose,
  Loading,
  RenderImages,
  handleImages,
  images,
  setImages,
  setIsdelete,
  setDeletedImages,
  setUpdateConvoImage,
  setUpdateConvoVideo,
  media,
  setMedia,
  isImageProcessing,
  editingImage,
  setEditingImage,
  setShowConvoFilePicker,
}) => {
  const dispatch = useDispatch();
  const dimensions = useWindowDimension();
  const mobile = dimensions?.width < 600 || false;
  const isMobile = dimensions?.width <= 500 || false;
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );

  const [isOpenBox, setIsOpenBox] = useState(false);
  const [emojiPicker, setEmojiPicker] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState([]);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const [isPublishEnabled, setIsPublishEnabled] = useState(false);

  const [showBgImgMenu, setShowBgImgMenu] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorInputRef = useRef<HTMLInputElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const editorContainerRef = useRef<HTMLDivElement | null>(null);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const bgImgMenuRef = useRef<HTMLDivElement | null>(null);

  const handleEmojiPicker = (e: any) => {
    const emoji = e?.native;
    if (editorRef?.current) {
      editorRef.current.insertHTML(emoji);
    }
    setEmojiPicker(!emojiPicker);
  };

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsOpenBox(false);
          setEmojiPicker(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        bgImgMenuRef.current &&
        !bgImgMenuRef.current.contains(event.target as Node)
      ) {
        setShowBgImgMenu(false);
        setShowColorPicker(false);
      }
    };

    if (showBgImgMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showBgImgMenu]);

  const hasContent = (html: string) => {
    // Convo disabled case
    if (isOpenConvo && !convo?.enabled) return false;

    // Parse HTML to get plain text
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html || "";
    let text = tempDiv.textContent || "";
    text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();

    // If there is text, media, or images, and entity is not deleted
    const hasText = text.length > 0;
    const hasMedia = (media?.length ?? 0) > 0 || (images?.length ?? 0) > 0;
    const isEntityValid = entityStatus !== "Deleted";

    if (isEntityValid && (hasText || hasMedia)) {
      // Case: recipient validation
      if (toFK?.length === 0) return false; // no recipient
      if (toFK?.length > 1 && !subject) return false; // multiple recipients but no subject
      return true;
    }

    // Check if HTML contains <img> or <video> tags
    if (tempDiv.querySelector("img, video")) return true;

    return false;
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(e.target as Node)
      ) {
        setShowColorPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleColorChange = (color: any) => {
    setBgImage("");
    setBgImgWidth("");
    setBgImgHeight("");
    setBgColor(color.hex);

    const editableArea = document.querySelector<HTMLDivElement>(
      ".sun-editor-editable",
    );
    if (editableArea) {
      editableArea.innerHTML = editableArea.innerHTML
        .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
        .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

      editableArea.style.backgroundImage = "unset";
      editableArea.style.backgroundSize = "unset";
      editableArea.style.backgroundPosition = "unset";
      editableArea.style.backgroundRepeat = "unset";
      editableArea.style.height = isExpanded ? "54vh" : "20vh";
      editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
      editableArea.style.width = "unset";
      editableArea.style.minWidth = "unset";

      editableArea.style.backgroundColor = color.hex;
    }
  };

  useEffect(() => {
    if (editorRef.current && useRichText && itemEdit?.text?.length > 0) {
      const cleanHTML = itemEdit.text.replace(
        /<figure[^>]*>(.*?)<\/figure>/g,
        "$1",
      );

      editorRef.current.setContents(cleanHTML);
      setRteValue(cleanHTML);

      // Delay DOM manipulation until SunEditor finishes rendering content
      setTimeout(() => {
        const div = document.createElement("div");
        div.innerHTML = cleanHTML;

        const wrapper = div.querySelector("div[style]") as HTMLElement | null;
        const editableArea = document.querySelector<HTMLDivElement>(
          ".sun-editor-editable",
        );

        if (!editableArea) return;

        // Reset background and size
        editableArea.style.backgroundColor = "unset";
        editableArea.style.backgroundImage = "unset";
        editableArea.style.backgroundSize = "unset";
        editableArea.style.backgroundPosition = "unset";
        editableArea.style.backgroundRepeat = "unset";
        editableArea.style.height = isExpanded ? "54vh" : "20vh";
        editableArea.style.minHeight = isExpanded ? "54vh" : "20vh";
        editableArea.style.width = "unset";
        editableArea.style.minWidth = "unset";

        let imgWidth = "";
        let imgHeight = "";

        if (wrapper) {
          const bgColorMatch = wrapper.style.backgroundColor;
          const bgImageMatch = wrapper.style.backgroundImage
            ?.replace(/url\(["']?(.+?)["']?\)/, "$1")
            ?.trim();

          imgWidth = wrapper.style.width;
          imgHeight = wrapper.style.height;
          setBgImgWidth(imgWidth);
          setBgImgHeight(imgHeight);

          const hasBgColorInHTML =
            wrapper.style.backgroundColor &&
            wrapper.style.backgroundColor !== "transparent" &&
            wrapper.style.backgroundColor !== "unset" &&
            wrapper.style.backgroundColor !== "none";

          const hasBgImageInHTML =
            wrapper.style.backgroundImage &&
            wrapper.style.backgroundImage !== "none" &&
            wrapper.style.backgroundImage !== "unset";

          // Background color
          if (!hasBgColorInHTML && (bgColorMatch || bgColor)) {
            const finalColor = bgColor?.length > 0 ? bgColor : bgColorMatch;
            editableArea.style.backgroundColor = finalColor || "unset";
            setBgColor(finalColor || "");
            setBgImage("");
            setBgImgWidth("");
            setBgImgHeight("");
          } else if (hasBgColorInHTML) {
            editableArea.style.backgroundColor = wrapper.style.backgroundColor;
            setBgColor(wrapper.style.backgroundColor);
            setBgImage("");
            setBgImgWidth("");
            setBgImgHeight("");
          }

          // Background image
          if (!hasBgImageInHTML && (bgImageMatch || bgImage)) {
            const finalImage = bgImage?.length > 0 ? bgImage : bgImageMatch;

            editableArea.style.backgroundImage = `url(${finalImage})`;
            editableArea.style.backgroundSize = "contain";
            editableArea.style.backgroundPosition = "left";
            editableArea.style.backgroundRepeat = "no-repeat";
            setBgImage(finalImage);
            setBgColor("");
          } else if (hasBgImageInHTML) {
            const imgUrl = wrapper.style.backgroundImage.replace(
              /url\(["']?(.+?)["']?\)/,
              "$1",
            );

            editableArea.style.backgroundImage = `url(${imgUrl})`;
            editableArea.style.backgroundSize = "contain";
            editableArea.style.backgroundPosition = "left";
            editableArea.style.backgroundRepeat = "no-repeat";
            setBgImage(imgUrl);
            setBgColor("");
          }
        }

        // Apply width/height after DOM render is stable
        if (imgHeight && imgWidth) {
          editableArea.style.height = imgHeight;
          editableArea.style.minHeight = imgHeight;
          editableArea.style.width = imgWidth;
          editableArea.style.minWidth = imgWidth;
        } else {
          editableArea.style.height = isExpanded ? "54vh" : "20vh";
        }
      }, 100); // small delay ensures the editor is ready
    }
  }, [itemEdit]);

  useEffect(() => {
    if (editorRef.current && useRichText) {
      const editableArea = document.querySelector<HTMLDivElement>(
        ".sun-editor-editable",
      );

      if (editableArea) {
        if (bgImgHeight && bgImgWidth) {
          editableArea.style.height = `${bgImgHeight}px`;
          editableArea.style.minHeight = `${bgImgHeight}px`;
          editableArea.style.width = `${bgImgWidth}px`;
          editableArea.style.minWidth = `${bgImgWidth}px`;
        } else {
          editableArea.style.height = isExpanded ? "54vh" : "20vh";
        }
      }
    }
  }, [isExpanded]);

  useEffect(() => {
    //if ((media?.length ?? 0) > 0 || (images?.length ?? 0) > 0) {
    setIsPublishEnabled(hasContent(rteValue));
    //}
  }, [media, images]);

  //useEffect(() => {
  //  console.log("Popup useRichText state: ", useRichText);
  //}, [useRichText]);

  function createFileList(files: File[]): FileList {
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    return dataTransfer.files;
  }

  function autoSetImageSize() {
    // File input
    const fileInput =
      document.querySelector<HTMLInputElement>("._se_image_file");
    if (fileInput) {
      fileInput.addEventListener("change", (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
          const img = new window.Image();
          img.onload = () => {
            document.querySelector<HTMLInputElement>(
              "._se_image_size_x",
            )!.value = String(img.width);
            document.querySelector<HTMLInputElement>(
              "._se_image_size_y",
            )!.value = String(img.height);
          };
          img.src = URL.createObjectURL(file);
        }
      });
    }

    // URL input
    const urlInput = document.querySelector<HTMLInputElement>("._se_image_url");
    if (urlInput) {
      urlInput.addEventListener("blur", () => {
        if (urlInput.value) {
          const img = new window.Image();
          img.onload = () => {
            document.querySelector<HTMLInputElement>(
              "._se_image_size_x",
            )!.value = String(img.width);
            document.querySelector<HTMLInputElement>(
              "._se_image_size_y",
            )!.value = String(img.height);
          };
          img.src = urlInput.value;
        }
      });
    }
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bgColor="rgba(0, 0, 0, 0.25)"
      zIndex={99999}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <div
        className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
        style={{
          width: isExpanded
            ? mobile
              ? "100%"
              : "90%"
            : mobile
              ? dimensions.width - 15
              : "700px",
          height: isExpanded ? "90vh" : "55vh",
          maxHeight: isExpanded ? "90vh" : "55vh",
          padding: isExpanded ? "30px" : "24px",
          top: isExpanded ? "50%" : "55%",
        }}
      >
        {/* Emoji Picker */}
        {emojiPicker && (
          <Box
            ref={menuRefs}
            position={mobile ? "fixed" : "absolute"}
            top={isExpanded ? "165px" : mobile ? 0 : "auto"}
            right={"65px"}
            zIndex={99}
            w={mobile ? "85%" : "88%"}
            mb={mobile ? 0 : 4}
          >
            <AVEmojiPicker onEmojiSelect={handleEmojiPicker} />
          </Box>
        )}

        <VStack height={"100%"}>
          {/* Header */}
          <HStack alignItems="center" justifyContent="space-between" mb="16px">
            <Text fontSize="24px" fontWeight="600">
              {itemEdit?.id?.length > 0
                ? Loc.currentLang.menu.editMessage
                : Loc.currentLang.message.newMessage}
            </Text>

            <HStack space={3} alignItems="center">
              {/* Expand / Collapse Button */}
              <Tooltip
                title={
                  isExpanded
                    ? Loc.currentLang.postPopup.collapse
                    : Loc.currentLang.postPopup.expand
                }
                style={{ top: "4px", zIndex: 10 }}
                arrow
              >
                <Pressable
                  onPress={() => {
                    setIsExpanded((prev) => !prev);
                    dispatch(setPostPopupExpanded((prev) => !prev));
                  }}
                >
                  {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
                </Pressable>
              </Tooltip>

              {/* Close Button */}
              <AVCancel
                callback={() => {
                  setItemEdit("");
                  setMedia([]);
                  setImages([]);
                  setRteValue("");
                  setUseRichText(false);
                  setUpdateConvoImage([]);
                  setUpdateConvoVideo([]);
                  setEditingImage(false);
                  setShowConvoFilePicker(false);
                  dispatch(setPostPopupExpanded(false));
                }}
                color={undefined}
                size={undefined}
              />
            </HStack>
          </HStack>

          <ScrollView
            showsHorizontalScrollIndicator={false}
            maxHeight={isExpanded ? "78vh" : "45vh"}
          >
            <div style={{ position: "relative" }}>
              {/* Editor */}
              <Box
                position="relative"
                borderColor="AVColor.grey"
                mb="16px"
                height={
                  bgImgHeight
                    ? `${Math.min((parseInt(bgImgHeight, 10) / window.innerHeight) * 100 + 7, 61)}vh`
                    : isExpanded
                      ? "61vh"
                      : "27vh"
                }
                maxHeight={isExpanded ? "61vh" : "27vh"}
                overflowY={useRichText ? "auto" : "unset"}
                overflowX="hidden"
                borderWidth={useRichText ? 0 : 1}
                borderRadius={useRichText ? 0 : "md"}
                zIndex={isConfirmDelete ? -3 : 99999}
              >
                <SunEditor
                  getSunEditorInstance={(editor) => {
                    editorRef.current = editor;

                    const editorContainer =
                      document.querySelector(".sun-editor");
                    if (!editorContainer) return;

                    // Watch for the Image Insert dialog opening
                    const observer = new MutationObserver(() => {
                      // Handle proportion checkbox
                      const proportionCheckbox =
                        document.querySelector<HTMLInputElement>(
                          "._se_image_check_proportion",
                        );
                      if (proportionCheckbox && proportionCheckbox.checked) {
                        autoSetImageSize();
                        proportionCheckbox.click(); // uncheck every time dialog opens
                      }

                      // Custom File Input Enhancements
                      const fileInput = document.querySelector(
                        "._se_image_file",
                      ) as HTMLInputElement;
                      if (
                        fileInput &&
                        !fileInput.parentElement?.querySelector(".file-status")
                      ) {
                        // Add dashed border style
                        const fileContainer = fileInput.closest(
                          ".se-dialog-form-files",
                        ) as HTMLElement;
                        if (fileContainer) {
                          fileContainer.style.position = "relative";
                          fileContainer.style.border = "2px dashed #ccc";
                          fileContainer.style.borderRadius = "8px";
                          fileContainer.style.padding = "12px";
                          fileContainer.style.textAlign = "center";
                        }

                        // Create wrapper for labels
                        const statusDiv = document.createElement("div");
                        statusDiv.className = "file-status";
                        statusDiv.innerHTML = `
                          <span class="upload-label">${Loc.currentLang.richText.uploadFile}</span>
                          <span class="file-status-text">${Loc.currentLang.richText.noFileChosen}</span>
                        `;
                        fileInput.parentElement?.appendChild(statusDiv);

                        // Handle file change event
                        fileInput.addEventListener("change", (e: Event) => {
                          const target = e.target as HTMLInputElement;
                          const file = target?.files?.[0] || null;
                          const statusText = statusDiv.querySelector(
                            ".file-status-text",
                          ) as HTMLElement;

                          if (file) {
                            statusText.textContent = file.name;
                            statusText.style.color = "#333";
                          } else {
                            statusText.textContent =
                              Loc.currentLang.richText.noFileChosen;
                            statusText.style.color = "#777";
                          }
                        });
                      }
                    });

                    // Observe editor container for dialogs being added
                    observer.observe(editorContainer, {
                      childList: true,
                      subtree: true,
                    });
                  }}
                  lang={
                    currentUser?.preferences?.lang
                      ? currentUser.preferences.lang === "en-us"
                        ? "en"
                        : currentUser.preferences.lang
                      : "en"
                  }
                  setOptions={{
                    ...toolbarOptions,
                    height: isExpanded ? "54vh" : "20vh",
                  }}
                  onChange={(value: string) => {
                    setRteValue(value);
                    setIsPublishEnabled(hasContent(value));
                  }}
                  setContents={rteValue.replace(
                    /<figure[^>]*>(.*?)<\/figure>/g,
                    "$1",
                  )}
                  autoFocus={true}
                />

                {/* Right-side Buttons (Top editor tool optionsBackground Controls) */}
                {useRichText && (
                  <HStack
                    position="absolute"
                    //right={isExpanded ? "calc(100% - 685px)" : "5px"}
                    right={isExpanded ? "calc(100% - 665px)" : "45px"}
                    top="5px"
                    zIndex={10}
                    flexDirection="row"
                    alignItems="center"
                    space={2}
                    borderWidth={1}
                    borderColor="#dadada"
                    borderRadius="6px"
                    //padding={isExpanded ? "4px 6px" : "4px 4px"}
                    padding={"8px 6px"}
                  >
                    <>
                      {/* Background Color Picker */}
                      <Box position="relative" display="inline-block" top="0px">
                        <Tooltip
                          title={Loc.currentLang.postPopup.backgroundColor}
                          arrow
                        >
                          <Pressable
                            onPress={() => setShowColorPicker(!showColorPicker)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <BrushIcon height="20" width="20" color="black" />
                          </Pressable>
                        </Tooltip>

                        {/* Color picker popup */}
                        {showColorPicker && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: isExpanded ? "40px" : "auto",
                              top: "40px",
                              right: "20px",
                              zIndex: 9999,
                              maxHeight: isExpanded ? "auto" : "150px",
                              overflowY: isExpanded ? "visible" : "auto",
                            }}
                            ref={colorPickerRef}
                          >
                            <Box
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                            >
                              {/* Color Picker */}
                              <SketchPicker
                                color={bgColor}
                                onChange={handleColorChange}
                              />

                              {/* Remove background color */}
                              {bgColor && (
                                <Tooltip
                                  title={
                                    Loc.currentLang.postPopup
                                      .removeBackgroundColor
                                  }
                                  arrow
                                >
                                  <Pressable
                                    alignSelf="flex-end"
                                    top="-25px"
                                    left="-14px"
                                    onPress={() => {
                                      setBgColor("");
                                      const editableArea =
                                        document.querySelector<HTMLDivElement>(
                                          ".sun-editor-editable",
                                        );
                                      if (editableArea)
                                        editableArea.style.backgroundColor =
                                          "unset";
                                      setShowColorPicker(false);
                                    }}
                                  >
                                    <CircleSlashIcon
                                      width={"14px"}
                                      height={"14px"}
                                    />
                                  </Pressable>
                                </Tooltip>
                              )}
                            </Box>
                          </div>
                        )}
                      </Box>

                      {/* Background Image Upload + Add/Remove Menu */}
                      {/*<Box position="relative" display="inline-block">*/}
                      {/*  <input*/}
                      {/*    type="file"*/}
                      {/*    accept="image/*"*/}
                      {/*    ref={(el) => (fileInputRef.current = el)}*/}
                      {/*    onChange={async (e) => {*/}
                      {/*      const file = e.target.files?.[0];*/}
                      {/*      if (!file) return;*/}

                      {/*      const fileList = createFileList([file]);*/}
                      {/*      if (!fileList) return;*/}

                      {/*      try {*/}
                      {/*        const data = await AV.Media.saveFiles(*/}
                      {/*          AV.Media.getFormData(fileList),*/}
                      {/*          currentUser?.region,*/}
                      {/*        );*/}

                      {/*        setBgColor("");*/}
                      {/*        const srclink = AV.Media.getURL(data[0]);*/}
                      {/*        setBgImage(srclink);*/}

                      {/*        const editableArea =*/}
                      {/*          document.querySelector<HTMLDivElement>(*/}
                      {/*            ".sun-editor-editable",*/}
                      {/*          );*/}
                      {/*        if (editableArea) {*/}
                      {/*           Create an image object to get its natural width and height*/}
                      {/*          const img = document.createElement(*/}
                      {/*            "img",*/}
                      {/*          ) as HTMLImageElement;*/}
                      {/*          img.src = srclink;*/}

                      {/*          img.onload = () => {*/}
                      {/*            const imgWidth = img.naturalWidth;*/}
                      {/*            const imgHeight = img.naturalHeight;*/}
                      {/*            setBgImgWidth(imgWidth.toString());*/}
                      {/*            setBgImgHeight(imgHeight.toString());*/}

                      {/*             Set editor background*/}
                      {/*            editableArea.style.backgroundColor = "unset";*/}
                      {/*            editableArea.style.backgroundImage = `url(${srclink})`;*/}
                      {/*            editableArea.style.backgroundSize = "contain";*/}
                      {/*            editableArea.style.backgroundPosition =*/}
                      {/*              "left";*/}
                      {/*            editableArea.style.backgroundRepeat =*/}
                      {/*              "no-repeat";*/}

                      {/*             Set editor height to image height or scale as needed*/}
                      {/*            editableArea.style.height = `${imgHeight}px`;*/}
                      {/*            editableArea.style.minHeight = `${imgHeight}px`;*/}
                      {/*            editableArea.style.width = `${imgWidth}px`;*/}
                      {/*            editableArea.style.minWidth = `${imgWidth}px`;*/}
                      {/*          };*/}
                      {/*        }*/}
                      {/*      } catch (err) {*/}
                      {/*        console.error(*/}
                      {/*          "Background image upload failed:",*/}
                      {/*          err,*/}
                      {/*        );*/}
                      {/*      }*/}
                      {/*    }}*/}
                      {/*    style={{ display: "none" }}*/}
                      {/*  />*/}

                      {/*   Background Image Options */}
                      {/*  <Tooltip title={Loc.currentLang.postPopup.backgroundImage} arrow>*/}
                      {/*    <Pressable*/}
                      {/*      onPress={() => {*/}
                      {/*        if (bgImage) setShowBgImgMenu(!showBgImgMenu);*/}
                      {/*        else fileInputRef.current?.click();*/}
                      {/*      }}*/}
                      {/*      style={{*/}
                      {/*        display: "flex",*/}
                      {/*        alignItems: "center",*/}
                      {/*        justifyContent: "center",*/}
                      {/*      }}*/}
                      {/*    >*/}
                      {/*      <ImportBGImage*/}
                      {/*        height="28"*/}
                      {/*        width="28"*/}
                      {/*        color="black"*/}
                      {/*      />*/}
                      {/*    </Pressable>*/}
                      {/*  </Tooltip>*/}

                      {/*   Menu List for Add/Remove */}
                      {/*  {showBgImgMenu && (*/}
                      {/*    <Box*/}
                      {/*      ref={bgImgMenuRef}*/}
                      {/*      position="absolute"*/}
                      {/*      top="40px"*/}
                      {/*      right="0"*/}
                      {/*      bg="white"*/}
                      {/*      borderWidth="1px"*/}
                      {/*      borderColor="#ddd"*/}
                      {/*      borderRadius="8px"*/}
                      {/*      shadow={3}*/}
                      {/*      zIndex={9999}*/}
                      {/*      p="2px"*/}
                      {/*      minW="70px"*/}
                      {/*    >*/}
                      {/*      <Pressable*/}
                      {/*        onPress={() => {*/}
                      {/*          fileInputRef.current?.click();*/}
                      {/*          setShowBgImgMenu(false);*/}
                      {/*        }}*/}
                      {/*      >*/}
                      {/*        <Box px={3} py={2}>*/}
                      {/*          <Text fontSize="14px">{Loc.currentLang.postPopup.add}</Text>*/}
                      {/*        </Box>*/}
                      {/*      </Pressable>*/}

                      {/*      <Pressable*/}
                      {/*        onPress={() => {*/}
                      {/*          setBgImage("");*/}
                      {/*          setBgImgWidth("");*/}
                      {/*          setBgImgHeight("");*/}

                      {/*          const editableArea =*/}
                      {/*            document.querySelector<HTMLDivElement>(*/}
                      {/*              ".sun-editor-editable",*/}
                      {/*            );*/}
                      {/*          if (editableArea) {*/}
                      {/*            editableArea.style.backgroundImage = "unset";*/}
                      {/*            editableArea.style.backgroundSize = "unset";*/}
                      {/*            editableArea.style.backgroundPosition =*/}
                      {/*              "unset";*/}
                      {/*            editableArea.style.backgroundRepeat = "unset";*/}

                      {/*            editableArea.style.height = isExpanded*/}
                      {/*              ? "54vh"*/}
                      {/*              : "20vh";*/}
                      {/*            editableArea.style.minHeight = isExpanded*/}
                      {/*              ? "54vh"*/}
                      {/*              : "20vh";*/}
                      {/*            editableArea.style.width = "unset";*/}
                      {/*            editableArea.style.minWidth = "unset";*/}
                      {/*          }*/}

                      {/*          setShowBgImgMenu(false);*/}
                      {/*        }}*/}
                      {/*      >*/}
                      {/*        <Box px={3} py={2}>*/}
                      {/*          <Text fontSize="14px" color="red.500">*/}
                      {/*            { Loc.currentLang.postPopup.remove }*/}
                      {/*          </Text>*/}
                      {/*        </Box>*/}
                      {/*      </Pressable>*/}
                      {/*    </Box>*/}
                      {/*  )}*/}
                      {/*</Box>*/}
                    </>
                  </HStack>
                )}

                {/* Right-side Buttons (Emoji) */}
                <HStack
                  position="absolute"
                  right="10px"
                  bottom="10px"
                  zIndex="10"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  space={1}
                >
                  <AVEmoji showEmoji={() => setEmojiPicker((prev) => !prev)} />
                </HStack>
              </Box>
            </div>

            {/* Render Images */}
            {images && images.length > 0 && (
              <Box mt="16px" width={"100%"}>
                <RenderImages
                  images={images}
                  setImages={setImages}
                  setDeletedImages={setDeletedImages}
                  media={media}
                  setIsdelete={setIsdelete}
                  setMedia={setMedia}
                  isImageProcessing={isImageProcessing}
                  editingImage={editingImage}
                  setUpdateConvoImage={setUpdateConvoImage}
                  setUpdateConvoVideo={setUpdateConvoVideo}
                  setEditingImage={setEditingImage}
                  itemEdit={itemEdit}
                  setItemEdit={setItemEdit}
                  setShowConvoFilePicker={setShowConvoFilePicker}
                  useRichText={useRichText}
                  isExpanded={isExpanded}
                />
              </Box>
            )}
          </ScrollView>

          {isOpenBox && (
            <ExternalLink
              setIsOpenBox={setIsOpenBox}
              setIsYouTube={setIsYouTube}
              setIsOpenCemera={setIsOpenCemera}
              setCameraMode={setCameraMode}
              imageInputRef={imageInputRef}
              menuRefs={menuRefs}
              handleOpenPicker={handleOpenPicker}
              setExternalLink={setExternalLink}
              HandleAddOneDrive={HandleAddOneDrive}
              setShowExternalLinkInput={setShowExternalLinkInput}
              showExternalLinkInput={showExternalLinkInput}
              HandleAddDropBoxLink={HandleAddDropBoxLink}
              setIsOneDriveData={setIsOneDriveData}
            />
          )}

          <input
            type="file"
            accept="image/jpeg,image/jfif,image/png,image/gif,video/mp4,"
            //accept="image/jpeg,image/jfif,image/png,image/webp,image/gif,video/mp4,"
            multiple
            hidden
            ref={imageInputRef}
            onChange={handleImages}
          />

          {/* Add to Post + Footer Buttons in Same Row */}
          <HStack
            justifyContent="space-between"
            alignItems="center"
            mt="32px"
            w="100%"
          >
            {/* Left: Add to Post */}
            <HStack alignItems="center" space={3}>
              <Button
                rounded="full"
                backgroundColor="AVColor.primary"
                p="15px"
                onPress={() => {
                  setIsOpenBox(!isOpenBox);
                  const closeBtn = document.querySelector(
                    ".se-btn.se-dialog-close",
                  ) as HTMLElement | null;
                  closeBtn?.click();
                }}
              >
                {!isOpenBox ? (
                  <AddIcon size="15px" color="AVColor.white" />
                ) : (
                  <CloseIcon size="15px" color="AVColor.white" />
                )}
              </Button>
              <Text fontSize="18px">{Loc.currentLang.post.addToYourPost}</Text>
            </HStack>

            {/* Right: Footer Buttons */}
            <HStack space={3}>
              <Button
                height="40px"
                w="120px"
                bg="gray.200"
                borderRadius="full"
                onPress={() => {
                  setItemEdit("");
                  setMedia([]);
                  setImages([]);
                  setRteValue("");
                  setUseRichText(false);
                  setUpdateConvoImage([]);
                  setUpdateConvoVideo([]);
                  setEditingImage(false);
                  setShowConvoFilePicker(false);
                  dispatch(setPostPopupExpanded(false));
                }}
              >
                <Text fontSize="16px">{Loc.currentLang.postPopup.cancel}</Text>
              </Button>

              <Button
                height="40px"
                w="120px"
                bg="AVColor.primary"
                borderRadius="full"
                onPress={() => {
                  if (itemEdit?.id?.length > 0) {
                    handleUpdatePost(itemEdit);
                  } else {
                    handleSendConvoMessage(convo);
                  }
                }}
                isDisabled={!isPublishEnabled}
                isLoading={isLoading || Loading || isImageProcessing}
              >
                <Text color="white" fontSize="16px">
                  {Loc.currentLang.postPopup.publish}
                </Text>
              </Button>
            </HStack>
          </HStack>
        </VStack>
      </div>

      {showExternalLinkInput && !isOpenCemera && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              isMobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              height: isMobile ? "650px" : "240px",
              marginTop: "12px",
            }}
          >
            <VStack width={"100%"} padding={"24px"}>
              <HStack
                justifyContent={"space-between"}
                width={"100%"}
                alignItems={"center"}
                marginTop={"20px"}
                borderBottomColor={"AVColor.grey"}
              >
                <Text fontSize={"24px"}>
                  {isYoutube
                    ? "Add Youtube Url"
                    : Loc.currentLang.postPopup.addPostUrl}
                </Text>
                <AVCancel
                  callback={() => {
                    setShowExternalLinkInput(false);
                  }}
                  color={undefined}
                  size={undefined}
                />
              </HStack>
              <HStack width={"100%"} marginTop={"24px"}>
                <Box width={"95%"} justifyContent="center">
                  <AVInputtext
                    type={"text"}
                    label={
                      isYoutube
                        ? Loc.currentLang.menu.addYoutubeUrl
                        : Loc.currentLang.postPopup.addPostUrl
                    }
                    onChange={handleExternalLink}
                    maxLength={undefined}
                    defaultValue={undefined}
                    width={undefined}
                    value={externalLink}
                    height={"20px"}
                    minRows={undefined}
                    multiline={undefined}
                    size={undefined}
                    placeholder={undefined}
                  />
                </Box>
              </HStack>
              <HStack
                justifyContent={"center"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"180px"}
                  height={"40px"}
                  backgroundColor={"AVColor.primary"}
                  rounded={"full"}
                  isDisabled={externalLink?.trim().length === 0}
                  isLoading={addLinkLoad}
                  onPress={() => HandleAddExternalUrl()}
                >
                  <Text fontWeight={500} color={"white"}>
                    {Loc.currentLang.menu.ok}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isOpenCemera && (
        <Box
          position="fixed"
          bgColor="rgba(0, 0, 0, 0.25)"
          bottom={0}
          right={0}
          top="40px"
          left={0}
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflowY="auto"
          px="16px" // horizontal padding for small screens
        >
          <Box
            bg="white"
            borderRadius="12px"
            p="20px"
            w="100%"
            maxW="750px"
            maxH="95vh"
            overflowY="auto"
          >
            <VStack space={4}>
              {/* Webcam preview */}
              <Box w="100%" position="relative">
                <Webcam
                  audio={cameraMode === "video"}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: "user" }}
                  style={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                {/* Timer Overlay */}
                {cameraMode === "video" && recording && (
                  <Box
                    position="absolute"
                    top="12px"
                    right="16px"
                    px="8px"
                    py="4px"
                    backgroundColor="rgba(0,0,0,0.6)"
                    borderRadius="md"
                  >
                    <Text color="white" fontWeight="bold" fontSize="md">
                      ⏺ {formatDuration(duration)}
                    </Text>
                  </Box>
                )}
              </Box>

              {/* Buttons */}
              <HStack
                flexWrap="wrap"
                justifyContent="flex-end"
                space={3}
                mt="20px"
                zIndex={100000}
              >
                {/* Toggle Camera Mode */}
                {/*<IconButton*/}
                {/*  icon={*/}
                {/*    cameraMode === "photo" ? (*/}
                {/*      <FiCamera size={20} color="#000" />*/}
                {/*    ) : (*/}
                {/*      <FiVideo size={20} color="#000" />*/}
                {/*    )*/}
                {/*  }*/}
                {/*  borderRadius="full"*/}
                {/*  backgroundColor="rgba(238, 238, 238, 1)"*/}
                {/*  onPress={toggleMode}*/}
                {/*  aria-label="Toggle Mode"*/}
                {/*/>*/}

                <div
                  className="toggleContainer"
                  style={{ display: "none" /*"flex"*/, gap: "12px" }}
                >
                  <div
                    className={`iconBox ${cameraMode === "photo" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiCamera size={24} />
                  </div>
                  <div
                    className={`iconBox ${cameraMode === "video" ? "active" : "inactive"}`}
                    onClick={() => toggleMode()}
                  >
                    <FiVideo size={24} />
                  </div>
                </div>

                {/* Cancel Button */}
                <Button
                  height="40px"
                  minW="120px"
                  backgroundColor="rgba(238, 238, 238, 1)"
                  borderRadius="full"
                  onPress={() => {
                    if (recording) {
                      isCancelledRef.current = true;
                      handleStopRecording();
                    }
                    onClose();
                  }}
                >
                  <Text
                    color="rgba(0, 0, 0, 0.5)"
                    fontSize="16px"
                    fontWeight={400}
                  >
                    {Loc.currentLang.postPopup.cancel}
                  </Text>
                </Button>

                {/* Capture / Record Button */}
                {cameraMode === "photo" ? (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor="AVColor.primary"
                    borderRadius="full"
                    isLoading={isImageProcessing}
                    onPress={handleCameraPhotoCapture}
                    //isDisabled={!isCameraAccessible}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {Loc.currentLang.postPopup.capture}
                    </Text>
                  </Button>
                ) : (
                  <Button
                    height="40px"
                    minW="120px"
                    backgroundColor={recording ? "red.500" : "AVColor.primary"}
                    borderRadius="full"
                    //isDisabled={!isCameraAccessible}
                    onPress={() => {
                      if (recording) {
                        isCancelledRef.current = false;
                        handleStopRecording();
                      } else {
                        handleStartRecording();
                      }
                    }}
                  >
                    <Text color="white" fontSize="16px" fontWeight={400}>
                      {recording
                        ? Loc.currentLang.postPopup.stop
                        : Loc.currentLang.postPopup.record}
                    </Text>
                  </Button>
                )}
              </HStack>
            </VStack>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FormattingPostPopup;
